import {CSSObject, styled} from "@mui/material/styles"
import merge from "lodash/merge"
import {ContainerStyles, ImageStyles} from "./models"
import {removeUnsetProps} from "../utils"

export const ImageContainer = styled("div", {shouldForwardProp: prop => !String(prop).startsWith("$")})<{
    $containerStyles: ContainerStyles
    $desktop: boolean
}>(({theme, $desktop, $containerStyles}) => {
    const override = removeUnsetProps({justifyContent: $containerStyles.alignment})
    return merge(
        {
            display: $desktop ? "none" : "flex",
            width: "100%",
            [theme.breakpoints.up("md")]: {
                display: $desktop ? "flex" : "none",
            },
        },
        override,
    )
})

/* 
    minHeight is included to try and reduce CLS, an exact height in overrides prevents the CLS
    however usually the image is expected to slightly resize depending on window width
    an override for minHeight to auto is needed to remove the extra padding if the object fit contain
 */

interface ISearchBannerImage {
    $imageStyles: ImageStyles
    $desktop: boolean
}

export const SearchBannerImage = styled("img", {
    shouldForwardProp: prop => !String(prop).startsWith("$"),
})<ISearchBannerImage>(({$imageStyles, $desktop}) => {
    const override = {
        objectFit: $desktop ? $imageStyles.objectFit : $imageStyles.mobileObjectFit,
        objectPosition: $desktop ? $imageStyles.desktopObjectPosition : $imageStyles.mobileObjectPosition,
        minHeight: $desktop ? $imageStyles.desktopMinHeight : $imageStyles.mobileMinHeight,
    }
    return merge(
        {
            maxWidth: "100%",
            minHeight: "200px",
            objectFit: "cover",
        },
        override,
    ) as CSSObject
})
